import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const saveProductionUnPickInboxReducer = (state = "", action) => {
  const actionName = serverApis.saveProductionUnPickInbox.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.referenceObject;

    case getResetAction(actionName):
      return "";
    default:
      return state;
  }
};
